@if (state(); as currentState) {
    @if (currentState && currentState.totalPages > 1) {
        <div
            class="flex flex-col items-center gap-2"
            *transloco="let t; prefix: 'uiPagination'">
            <nav>
                <ul class="flex list-unstyled h-[38px] text-primary mb-0">
                    <li>
                        <a
                            [attr.title]="t('previousPage')"
                            [attr.aria-label]="t('previousPage')"
                            [ngClass]="{
                                'pointer-events-none not-sr-only': currentState.previousPage === -1,
                                'hover:border-2 hover:border-primary group': currentState.previousPage !== -1,
                            }"
                            [routerLink]="currentState.url"
                            [queryParams]="{ page: currentState.previousPage }"
                            (click)="handleClick($event, currentState.previousPage)"
                            class="w-[38px] h-full primary-dark bg-gray-400 dark:bg-dark-contrast! flex items-center justify-center focus:-outline-offset-1">
                            <big-icon
                                [icon]="iconAngleLeft"
                                [size]="'w-4'"
                                [ngClass]="{
                                    'fill-gray-200 dark:opacity-50': currentState.previousPage === -1,
                                    'fill-primary dark:fill-white': currentState.previousPage !== -1,
                                }" />
                        </a>
                    </li>

                    @for (page of currentState.pages; track $index) {
                        <li>
                            @if (page !== -1) {
                                <a
                                    [attr.title]="t('pageLabel', { currentPage: page, total: currentState.totalPages })"
                                    [attr.aria-label]="t('pageLabel', { currentPage: page, total: currentState.totalPages })"
                                    [ngClass]="{
                                        'bg-primary text-white font-bold focus:text-white hover:text-white': page === currentState.currentPage,
                                        'bg-gray-400 dark:bg-dark-contrast text-primary dark:text-white hover:border-2 hover:border-primary':
                                            page !== currentState.currentPage,
                                        'w-[10px]': page === -1,
                                    }"
                                    [routerLink]="currentState.url"
                                    [queryParams]="{ page: page }"
                                    [queryParamsHandling]="'merge'"
                                    (click)="handleClick($event, page)"
                                    class="w-[38px] h-full primary-dark no-underline flex items-center justify-center focus:-outline-offset-1">
                                    {{ page }}
                                </a>
                            } @else {
                                <span class="flex items-center justify-center w-4 h-full bg-gray-400 primary-dark">…</span>
                            }
                        </li>
                    }

                    <li>
                        <a
                            [attr.title]="t('nextPage')"
                            [attr.aria-label]="t('nextPage')"
                            [ngClass]="{
                                'pointer-events-none not-sr-only': currentState.nextPage === -1,
                                'hover:border-2 hover:border-primary group': currentState.nextPage !== -1,
                            }"
                            [routerLink]="currentState.url"
                            [queryParams]="{ page: currentState.nextPage }"
                            [queryParamsHandling]="'merge'"
                            (click)="handleClick($event, currentState.nextPage)"
                            class="w-[38px] h-full primary-dark bg-gray-400 dark:bg-dark-contrast! flex items-center justify-center focus:-outline-offset-1">
                            <big-icon
                                [icon]="iconAngleRight"
                                [size]="'w-4'"
                                [ngClass]="{
                                    'fill-gray-200 dark:opacity-50': currentState.nextPage === -1,
                                    'fill-primary dark:fill-white': currentState.nextPage !== -1,
                                }" />
                        </a>
                    </li>
                </ul>
            </nav>
            @if (showItemsCount()) {
                <span class="text-center">
                    {{ t('results') }}
                    <strong>
                        {{ (currentState.currentPage - 1) * currentState.pageSize + 1 }} -
                        @if (currentState.currentPage === currentState.totalPages) {
                            {{ currentState.totalItems }}
                        } @else {
                            {{ currentState.currentPage * currentState.pageSize }}
                        }
                    </strong>
                    {{ t('of') }}
                    <strong>{{ currentState.totalItems }}</strong>
                </span>
            }
        </div>
    }
}
